import store from '@/store';

const countryFromAlpha2Code = (alpha2Code, fallback = undefined) => {
    return store.getters['countries/countryFromAlpha2Code'](alpha2Code, fallback);
};

export default countryFromAlpha2Code;
